import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ProductContext } from "../context/AppContext";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "antd/lib/date-picker";
import Header from "./Header";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import { Accordion, Button, Form, Row, Col, Card, Container, Alert as BsAlert, Badge } from "react-bootstrap";
import {
    FaChevronDown,
    FaChevronUp,
    FaHistory,
    FaUpload,
    FaEdit,
    FaImage,
    FaUser,
    FaIdCard,
    FaCalendar,
    FaMapMarkerAlt,
    FaPhone,
    FaEnvelope,
    FaLink,
    FaFileAlt,
    FaFileMedical,
    FaInfoCircle,
    FaCheckCircle,
    FaClock,
    FaExclamationTriangle
} from 'react-icons/fa';
import 'antd/dist/reset.css';

const UpdateDetails = () => {
    const { GetstudentData, casteData, cityData, religionData, userId } = useContext(ProductContext);
    const navigate = useNavigate();
    const location = useLocation();
    const routes = all_routes;

    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const sessionYear = `${currentYear}-${nextYear}`;

    const [formData, setFormData] = useState({
        regs_id: '',
        class_section_id: '',
        session: '',
        updated_field: '',
        new_value: '',
        user_reason: '',
        optional_document: '',
        character_certificate: '',
        medical_certificate: '',
        cast_certificate: '',
        domicile: '',
        id_proof: '',
        student_full_name: '',
        date_of_birth: '',
        aadhar_no: '',
        contact_address: '',
        father_full_name: '',
        father_mobile_no: '',
        father_email: '',
        father_aadhar_no: '',
        mother_full_name: '',
        mother_mobile_no: '',
        mother_email: '',
        mother_aadhar_no: '',
        guardian_name: '',
        guardian_mobile_no: '',
        guardian_email: '',
        guardian_aadhar_no: '',
        guardian_relation: '',
    });

    const [allClass, setAllClass] = useState([]);
    const [getStudentInfoUser, setGetStudentInfoUser] = useState([]);

    console.log(getStudentInfoUser, "getStudentInfoUser data1")
    const [loading, setLoading] = useState(false);
    const [activeSections, setActiveSections] = useState([]);
    const authtoken = localStorage.getItem("token");
    const [previews, setPreviews] = useState({
        optional_document: null,
        character_certificate: null,
        medical_certificate: null,
        cast_certificate: null,
        student_photo: null,
        father_photo: null,
        mother_photo: null,
    });
    const [filePreviews, setFilePreviews] = useState({
        optional_document: null,
        character_certificate: null,
        medical_certificate: null,
        cast_certificate: null,
        student_photo: null,
        father_photo: null,
        mother_photo: null,
    });
    const [selectedDate, setSelectedDate] = useState('');

    // Safe value helper
    const safeValue = val => (val && val !== "null" && val !== null ? val : '');

    const FatherName = safeValue(GetstudentData?.father_full_name);
    const FatherMobile = safeValue(GetstudentData?.father_mobile_no);
    const FatherEmail = safeValue(GetstudentData?.father_email);
    const FatherAadhar = safeValue(GetstudentData?.father_aadhar_no);

    const MotherName = safeValue(GetstudentData?.mother_full_name);
    const MotherMobile = safeValue(GetstudentData?.mother_mobile_no);
    const MotherEmail = safeValue(GetstudentData?.mother_email);
    const MotherAadhar = safeValue(GetstudentData?.mother_aadhar_no);

    const GuardianName = safeValue(GetstudentData?.guardian_name);
    const GuardianMobile = safeValue(GetstudentData?.guardian_mobile_no);
    const GuardianEmail = safeValue(GetstudentData?.guardian_email);
    const GuardianAadhar = safeValue(GetstudentData?.guardian_aadhar_no);
    const GuardianRelation = safeValue(GetstudentData?.guardian_relation);

    const SECTIONS = [
        {
            title: 'Full Name',
            field: 'student_full_name',
            icon: <FaUser className="text-primary" />,
            category: 'Personal Details'
        },
        {
            title: 'Date Of Birth',
            field: 'date_of_birth',
            icon: <FaCalendar className="text-info" />,
            category: 'Personal Details'
        },
        {
            title: 'Aadhar Number',
            field: 'aadhar_no',
            icon: <FaIdCard className="text-warning" />,
            category: 'Personal Details'
        },
        {
            title: 'Full Address',
            field: 'contact_address',
            icon: <FaMapMarkerAlt className="text-danger" />,
            category: 'Personal Details'
        },
        ...(FatherName ? [{
            title: 'Father Full Name',
            field: 'father_full_name',
            icon: <FaUser className="text-primary" />,
            category: 'Father Details'
        }] : []),
        ...(FatherMobile ? [{
            title: 'Father Mobile Number',
            field: 'father_mobile_no',
            icon: <FaPhone className="text-success" />,
            category: 'Father Details'
        }] : []),
        ...(FatherEmail ? [{
            title: 'Father Email',
            field: 'father_email',
            icon: <FaEnvelope className="text-info" />,
            category: 'Father Details'
        }] : []),
        ...(FatherAadhar ? [{
            title: 'Father Aadhar Number',
            field: 'father_aadhar_no',
            icon: <FaIdCard className="text-warning" />,
            category: 'Father Details'
        }] : []),
        ...(MotherName ? [{
            title: 'Mother Full Name',
            field: 'mother_full_name',
            icon: <FaUser className="text-primary" />,
            category: 'Mother Details'
        }] : []),
        ...(MotherMobile ? [{
            title: 'Mother Mobile Number',
            field: 'mother_mobile_no',
            icon: <FaPhone className="text-success" />,
            category: 'Mother Details'
        }] : []),
        ...(MotherEmail ? [{
            title: 'Mother Email',
            field: 'mother_email',
            icon: <FaEnvelope className="text-info" />,
            category: 'Mother Details'
        }] : []),
        ...(MotherAadhar ? [{
            title: 'Mother Aadhar Number',
            field: 'mother_aadhar_no',
            icon: <FaIdCard className="text-warning" />,
            category: 'Mother Details'
        }] : []),
        ...(GuardianName ? [{
            title: 'Guardian Full Name',
            field: 'guardian_name',
            icon: <FaUser className="text-primary" />,
            category: 'Guardian Details'
        }] : []),
        ...(GuardianMobile ? [{
            title: 'Guardian Mobile Number',
            field: 'guardian_mobile_no',
            icon: <FaPhone className="text-success" />,
            category: 'Guardian Details'
        }] : []),
        ...(GuardianEmail ? [{
            title: 'Guardian Email',
            field: 'guardian_email',
            icon: <FaEnvelope className="text-info" />,
            category: 'Guardian Details'
        }] : []),
        ...(GuardianAadhar ? [{
            title: 'Guardian Aadhar Number',
            field: 'guardian_aadhar_no',
            icon: <FaIdCard className="text-warning" />,
            category: 'Guardian Details'
        }] : []),
        ...(GuardianRelation ? [{
            title: 'Guardian Relation',
            field: 'guardian_relation',
            icon: <FaLink className="text-secondary" />,
            category: 'Guardian Details'
        }] : []),
        {
            title: 'Character Certificate',
            field: 'character_certificate',
            icon: <FaFileAlt className="text-primary" />,
            type: 'document',
            category: 'Documents'
        },
        {
            title: 'Medical Certificate',
            field: 'medical_certificate',
            icon: <FaFileMedical className="text-danger" />,
            type: 'document',
            category: 'Documents'
        },
        {
            title: 'Caste Certificate',
            field: 'cast_certificate',
            icon: <FaFileAlt className="text-warning" />,
            type: 'document',
            category: 'Documents'
        },
        {
            title: 'Student Photo',
            field: 'upload_photo',
            icon: <FaImage className="text-success" />,
            type: 'photo',
            category: 'Photos'
        },
        ...(safeValue(GetstudentData?.father_photo?.link) ? [{
            title: 'Father Photo',
            field: 'father_photo',
            icon: <FaImage className="text-info" />,
            type: 'photo',
            category: 'Photos'
        }] : []),
        ...(safeValue(GetstudentData?.mother_photo_upload?.link) ? [{
            title: 'Mother Photo',
            field: 'mother_photo_upload',
            icon: <FaImage className="text-info" />,
            type: 'photo',
            category: 'Photos'
        }] : []),
    ];

    // Group sections by category
    const groupedSections = SECTIONS.reduce((acc, section) => {
        const category = section.category;
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(section);
        return acc;
    }, {});

    useEffect(() => {
        const fetchClassData = async () => {
            try {
                const response = await fetch("https://api.mirai.healthcare/api/masters/classes");
                const result = await response.json();
                if (response.ok) {
                    setAllClass(result.data);
                }
            } catch (error) {
                console.error("Error fetching class data:", error);
            }
        };
        fetchClassData();
    }, []);

    useEffect(() => {
        const fetchGetStudentInfoData = async () => {
            try {
                const response = await fetch(`https://api.mirai.healthcare/api/student/audit`, {
                    headers: {
                        "x-auth": authtoken
                    }
                });
                const result = await response.json();
                if (response.ok) {
                    setGetStudentInfoUser(result.message || []);
                }
            } catch (error) {
                console.error("Error fetching audit data:", error);
            }
        };
        if (userId) {
            fetchGetStudentInfoData();
        }
    }, [userId]);

    useEffect(() => {
        if (GetstudentData) {
            const dobFormatted = GetstudentData?.date_of_birth ? moment(GetstudentData.date_of_birth).format('YYYY-MM-DD') : '';
            setSelectedDate(dobFormatted);
            setFormData(prev => ({
                ...prev,
                student_full_name: safeValue(GetstudentData?.student_full_name),
                date_of_birth: dobFormatted,
                aadhar_no: safeValue(GetstudentData?.aadhar_no),
                contact_address: safeValue(GetstudentData?.contact_address),
                father_full_name: safeValue(GetstudentData?.father_full_name),
                father_mobile_no: safeValue(GetstudentData?.father_mobile_no),
                father_email: safeValue(GetstudentData?.father_email),
                father_aadhar_no: safeValue(GetstudentData?.father_aadhar_no),
                mother_full_name: safeValue(GetstudentData?.mother_full_name),
                mother_mobile_no: safeValue(GetstudentData?.mother_mobile_no),
                mother_email: safeValue(GetstudentData?.mother_email),
                mother_aadhar_no: safeValue(GetstudentData?.mother_aadhar_no),
                guardian_name: safeValue(GetstudentData?.guardian_name),
                guardian_mobile_no: safeValue(GetstudentData?.guardian_mobile_no),
                guardian_email: safeValue(GetstudentData?.guardian_email),
                guardian_aadhar_no: safeValue(GetstudentData?.guardian_aadhar_no),
                guardian_relation: safeValue(GetstudentData?.guardian_relation),
                character_certificate: safeValue(GetstudentData?.character_certificate),
                medical_certificate: safeValue(GetstudentData?.medical_certificate),
                cast_certificate: safeValue(GetstudentData?.cast_certificate),
                regs_id: GetstudentData?.regs_id || '',
                class_section_id: GetstudentData?.class_section_id || '',
                session: GetstudentData?.session || '',
            }));
            // Set existing previews for documents and photos
            setPreviews(prev => ({
                ...prev,
                character_certificate: GetstudentData?.character_certificate && typeof GetstudentData.character_certificate === 'object' ? GetstudentData.character_certificate : null,
                medical_certificate: GetstudentData?.medical_certificate && typeof GetstudentData.medical_certificate === 'object' ? GetstudentData.medical_certificate : null,
                cast_certificate: GetstudentData?.cast_certificate && typeof GetstudentData.cast_certificate === 'object' ? GetstudentData.cast_certificate : null,
                student_photo: GetstudentData?.upload_photo || null,
                father_photo: GetstudentData?.father_photo || null,
                mother_photo: GetstudentData?.mother_photo_upload || null,
            }));
        }
    }, [GetstudentData]);

    const isPendingUpdate = (field) => {
        return getStudentInfoUser?.some(request => request.updated_field === field && request.status === 'Pending');
    };

    const getUpdateStatus = (field) => {
        const request = getStudentInfoUser?.find(req => req.updated_field === field);
        return request ? request.status : null;
    };

    const handleChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const handleDateChange = (date) => {
        const formattedDate = date ? date.format('YYYY-MM-DD') : '';
        setSelectedDate(formattedDate);
        setFormData(prev => ({
            ...prev,
            new_value: formattedDate,
            updated_field: 'date_of_birth',
        }));
    };


    // Safe file preview handler
    const handleFileChange = (field, file, previewKey) => {
        if (file) {
            setPreviews(prev => ({ ...prev, [field]: file }));
            // setFormData(prev => ({ ...prev, new_value: file.name }));

            // Create object URL safely
            try {
                const objectUrl = URL.createObjectURL(file);
                setFilePreviews(prev => ({ ...prev, [previewKey]: objectUrl }));
            } catch (error) {
                console.error('Error creating object URL:', error);
                setFilePreviews(prev => ({ ...prev, [previewKey]: null }));
            }
        }
    };

    // Clean up object URLs when component unmounts
    useEffect(() => {
        return () => {
            Object.values(filePreviews).forEach(url => {
                if (url && typeof url === 'string') {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, []);

    const handleUpdate = async (field) => {
        if (isPendingUpdate(field)) {
            Swal.fire('Info', 'Your update request is already under review. Please wait for approval.');
            return;
        }

        if (!formData.new_value && !previews[field]) {
            Swal.fire('Warning', 'Please provide a new value or upload a file before updating.', 'warning');
            return;
        }

        if (!formData.user_reason) {
            Swal.fire('Warning', 'Please provide a reason for the update.', 'warning');
            return;
        }

        setLoading(true);
        const classSectionId = formData.class_section_id ? parseInt(formData.class_section_id, 10) : null;
        const regsId = formData.regs_id ? parseInt(formData.regs_id, 10) : null;

        const data = new FormData();
        data.append('updated_field', field);
        data.append('user_reason', formData.user_reason);
        data.append('new_value', formData.new_value);
        data.append('regs_id', regsId);
        data.append('class_section_id', classSectionId);
        data.append('session', formData.session);

        if (previews.optional_document) {
            data.append('optional_document', previews.optional_document);
        }

        // Append specific files based on field
        const fileFields = {
            'character_certificate': 'character_certificate',
            'medical_certificate': 'medical_certificate',
            'cast_certificate': 'cast_certificate',
            'upload_photo': 'upload_photo',
            'father_photo': 'father_photo',
            'mother_photo_upload': 'mother_photo_upload',
        };
        const fileKey = fileFields[field];
        if (fileKey && previews[fileKey]) {
            data.append(fileKey, previews[fileKey]);
        }

        try {
            const response = await fetch("https://api.mirai.healthcare/api/student/audit", {
                method: "POST",
                body: data,
                headers: {
                    "x-auth": authtoken,
                    Accept: "application/json",
                },
            });

            const result = await response.json();
            if (response.ok) {
                Swal.fire('Success', 'Update request submitted successfully!', 'success');
                setFormData(prev => ({ ...prev, new_value: '', user_reason: '' }));
                setPreviews(prev => ({ ...prev, optional_document: null }));
                setFilePreviews(prev => ({ ...prev, optional_document: null }));

                // Refetch audit data
                const fetchGetStudentInfoData = async () => {
                    const res = await fetch(`https://api.mirai.healthcare/api/student/audit`, {
                        headers: { "x-auth": authtoken }
                    });
                    const auditResult = await res.json();
                    setGetStudentInfoUser(auditResult.message || []);
                };
                fetchGetStudentInfoData();
            } else {
                Swal.fire('Error', result.message || 'Something went wrong!', 'error');
            }
        } catch (error) {
            Swal.fire('Error', 'Failed to submit update request', 'error');
        } finally {
            setLoading(false);
        }
    };

    const renderStatusBadge = (field) => {
        const status = getUpdateStatus(field);
        if (!status) return null;

        const statusConfig = {
            'Pending': { variant: 'warning', icon: <FaClock className="me-1" /> },
            'Approved': { variant: 'success', icon: <FaCheckCircle className="me-1" /> },
            'Rejected': { variant: 'danger', icon: <FaExclamationTriangle className="me-1" /> }
        };

        const config = statusConfig[status];
        if (!config) return null;

        return (
            <Badge bg={config.variant} className="ms-2">
                {config.icon} {status}
            </Badge>
        );
    };

    const renderHeader = (section, index, isActive) => (
        <div
            className="d-flex align-items-center justify-content-between p-3 border-bottom cursor-pointer bg-light-hover"
            onClick={() => {
                setActiveSections(prev =>
                    prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                );
            }}
            style={{ cursor: 'pointer' }}
        >
            <div className="d-flex align-items-center">
                <div className="me-3">
                    {section.icon}
                </div>
                <div>
                    <h6 className="mb-0 fw-semibold">{section.title}</h6>
                    <small className="text-muted">Click to {isActive ? 'collapse' : 'expand'}</small>
                </div>
                {renderStatusBadge(section.field)}
            </div>
            <div>
                {isActive ? <FaChevronUp className="text-muted" /> : <FaChevronDown className="text-muted" />}
            </div>
        </div>
    );

    const renderContent = (section) => {
        const { field, type } = section;
        const currentValue = formData[field] || '';
        const isDocumentOrPhoto = type === 'document' || type === 'photo';
        const previewKey = field;

        if (isPendingUpdate(field)) {
            return (
                <BsAlert variant="warning" className="m-3">
                    <FaInfoCircle className="me-2" />
                    Your update request for <strong>{section.title}</strong> is under review.
                    Please wait for approval before making another update.
                </BsAlert>
            );
        }

        return (
            <Container fluid className="p-3">
                <Row className="g-3">
                    <Col md={6}>
                        <Card className="h-100">
                            <Card.Header className="bg-light">
                                <h6 className="mb-0">Current {section.title}</h6>
                            </Card.Header>
                            <Card.Body>
                                {!isDocumentOrPhoto ? (
                                    <Form.Control
                                        type={field.includes('email') ? 'email' : field.includes('mobile') || field.includes('aadhar') ? 'number' : 'text'}
                                        value={currentValue}
                                        disabled
                                        className="bg-light"
                                    />
                                ) : (
                                    <div className="text-center">
                                        {previews[previewKey]?.link ? (
                                            <img
                                                src={previews[previewKey].link}
                                                alt={section.title}
                                                className="img-thumbnail"
                                                style={{ maxWidth: '100%', maxHeight: '200px' }}
                                            />
                                        ) : (
                                            <div className="border rounded p-4 text-muted">
                                                <FaImage size={48} className="mb-2" />
                                                <p>No {section.title.toLowerCase()} available</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card className="h-100">
                            <Card.Header className="bg-light">
                                <h6 className="mb-0">New {section.title}</h6>
                            </Card.Header>
                            <Card.Body>
                                {field === 'date_of_birth' ? (
                                    <DatePicker
                                        className="form-control w-100"
                                        format="YYYY-MM-DD"
                                        value={selectedDate ? moment(selectedDate, "YYYY-MM-DD") : null}
                                        onFocus={() => setSelectedDate("")}
                                        onChange={handleDateChange}
                                    />

                                ) : isDocumentOrPhoto ? (
                                    <div>
                                        <Form.Label className="d-block">
                                            <FaUpload className="me-1" />
                                            Upload New {section.title}
                                        </Form.Label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    handleFileChange(field, file, previewKey);
                                                }
                                            }}
                                            className="form-control"
                                        />
                                        {filePreviews[previewKey] && (
                                            <div className="mt-2 text-center">
                                                <img
                                                    src={filePreviews[previewKey]}
                                                    alt="New Preview"
                                                    className="img-thumbnail"
                                                    style={{ maxWidth: '100%', maxHeight: '150px' }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <Form.Control
                                        type={field.includes('email') ? 'email' : field.includes('mobile') || field.includes('aadhar') ? 'number' : 'text'}
                                        value={formData.new_value || ''}
                                        onChange={(e) => {
                                            handleChange('new_value', e.target.value);
                                            handleChange('updated_field', field);
                                        }}
                                        placeholder={`Enter new ${section.title.toLowerCase()}`}
                                    />
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={8}>
                        <Form.Group>
                            <Form.Label>
                                <FaEdit className="me-1" />
                                Reason for Update
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formData.user_reason || ''}
                                onChange={(e) => handleChange('user_reason', e.target.value)}
                                placeholder="Please provide a detailed reason for this update..."
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {!isDocumentOrPhoto && (
                            <Form.Group>
                                <Form.Label>
                                    <FaUpload className="me-1" />
                                    Supporting Document
                                </Form.Label>
                                <input
                                    type="file"
                                    accept="image/*,.pdf,.doc,.docx"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            handleFileChange('optional_document', file, 'optional_document');
                                        }
                                    }}
                                    className="form-control"
                                />
                                {filePreviews.optional_document && (
                                    <div className="mt-2">
                                        <small className="text-success">
                                            <FaCheckCircle className="me-1" />
                                            File selected: {previews.optional_document?.name}
                                        </small>
                                        <div className="mt-2 text-center">
                                            <img
                                                src={filePreviews.optional_document}
                                                alt="Supporting Document Preview"
                                                className="img-thumbnail"
                                                style={{ maxWidth: '100%', maxHeight: '100px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </Form.Group>
                        )}
                    </Col>
                </Row>

                <div className="text-end mt-3">
                    <Button
                        variant="primary"
                        onClick={() => handleUpdate(field)}
                        disabled={loading || !formData.user_reason || (!formData.new_value && !previews[field])}
                        className="px-4"
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Submitting...
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="me-2" />
                                Submit Update Request
                            </>
                        )}
                    </Button>
                </div>
            </Container>
        );
    };

    return (
        
        <div className="page-wrapper">
            <div className="content content-two">
                <Header />
                <Container fluid>
                    
                    {/* Header Section */}
                    <Row className="align-items-center justify-content-between mt-3 my-2 pb-3">
                        <Col xs={12} md={8}>
                            <div className="d-flex align-items-center mb-2">
                                <FaEdit className="text-primary me-2" size={24} />
                               <h2
              className="page-title fw-bold mb-0"
              style={{ letterSpacing: "0.5px" }}
            >Update Student Details</h2>
                            </div>
                            
                        </Col>
                        <Col xs={12} md={4} className="text-md-end mt-2 mt-md-0">
                            <Link to="/update-history" className="btn btn-outline-primary btn-sm">
                                <FaHistory className="me-1" /> Update History
                            </Link>
                        </Col>
                    </Row>

                    {/* Student Info Card */}
                    {GetstudentData && (
                        <Row className="mb-4">
                            <Col xs={12}>
                                <Card className="bg-light">
                                    <Card.Body className="py-3">
                                        <Row className="align-items-center">
                                            <Col xs={12} md={8}>
                                                <h5 className="mb-1">{GetstudentData.student_full_name}</h5>
                                                <p className="text-muted mb-0">
                                                    Registration ID: {GetstudentData.regs_id} |
                                                    Session: {sessionYear}
                                                </p>
                                            </Col>
                                            <Col xs={12} md={4} className="text-md-end">
                                                <Badge bg="info" className="fs-6">
                                                    Student
                                                </Badge>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}

                    {/* Update Sections */}
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <Card.Header className="bg-white border-bottom">
                                    <h5 className="mb-0">Update Fields</h5>
                                    <small className="text-muted">
                                        Expand each section to update student information. All updates require approval.
                                    </small>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    {Object.entries(groupedSections).map(([category, sections]) => (
                                        <div key={category} className="border-bottom">
                                            <div className="bg-light px-3 py-2">
                                                <h6 className="mb-0 text-uppercase text-muted small fw-bold">
                                                    {category}
                                                </h6>
                                            </div>
                                            {sections.map((section, index) => (
                                                <Card key={index} className="border-0 rounded-0">
                                                    <Card.Header className="p-0 bg-transparent">
                                                        {renderHeader(section, index, activeSections.includes(index))}
                                                    </Card.Header>
                                                    {activeSections.includes(index) && (
                                                        <Card.Body className="p-0">{renderContent(section)}</Card.Body>
                                                    )}
                                                </Card>
                                            ))}
                                        </div>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default UpdateDetails;